var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5181 18.4203C49.9254 13.7499 59.5879 11.0653 69.8719 11V32.1744C68.9712 32.3319 68.1821 32.8141 67.6298 33.4959L41.5181 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5924 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 37.1628L97.5762 50.7844C98.1288 50.098 98.9208 49.6124 99.8253 49.4542L99.8253 19.271L73.8777 34.2519C74.1031 34.7309 74.2292 35.266 74.2292 35.8306C74.2292 36.3001 74.142 36.7493 73.9829 37.1628Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8989 11.002C81.1404 11.1104 90.759 13.8165 99.127 18.4927L73.3185 33.3933C72.7162 32.702 71.862 32.2358 70.8989 32.1379V11.002Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1036 34.373L40.9465 19.2712L40.9465 49.418C41.9136 49.5164 42.7708 49.986 43.3736 50.682L67.0069 37.0373C66.8769 36.659 66.8064 36.2532 66.8064 35.8308C66.8064 35.3133 66.9123 34.8206 67.1036 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.341C31.4054 24.4265 24.2705 31.5887 19.2178 40.1287L37.6745 50.7847C38.2271 50.0983 39.019 49.6126 39.9236 49.4544L39.9236 19.341Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0145C13.9327 49.4029 11.1518 59.0691 11 69.3722L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1108C36.8533 52.5973 36.9576 52.1081 37.1462 51.6633L18.7019 41.0145Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 84.0145V56.7672C38.9323 56.5943 38.0783 56.0303 37.5241 55.2406L11.5049 70.2628L37.6578 85.3622C38.211 84.6665 39.0087 84.174 39.9209 84.0145Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1534C11.1518 81.4565 13.9327 91.1227 18.7019 99.5111L37.0649 88.9092C36.9279 88.5219 36.8533 88.1051 36.8533 87.6708C36.8533 87.1652 36.9544 86.6832 37.1375 86.2439L11 71.1534Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9426 91.1553 38.0941 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8719 129.526C59.5879 129.46 49.9254 126.776 41.5181 122.105L67.4944 107.108C68.049 107.883 68.8948 108.436 69.8719 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0863 103.534L43.5154 89.9255C42.9094 90.7168 41.9922 91.2572 40.9465 91.3635L40.9465 121.254L67.0218 106.2C66.8823 105.809 66.8064 105.389 66.8064 104.951C66.8064 104.449 66.9059 103.971 67.0863 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 122.033C90.759 126.709 81.1404 129.415 70.8989 129.523V108.643C71.9406 108.537 72.855 108.001 73.461 107.214L99.127 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.443 89.8187L73.8979 103.412C74.1117 103.881 74.2307 104.402 74.2307 104.951C74.2307 105.436 74.1376 105.9 73.9681 106.325L99.8269 121.254V91.3271C98.8459 91.1556 97.9974 90.5989 97.443 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2572 102.814 90.7168 103.42 89.9255L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0775 121.878 99.3995L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5934 103.846 86.1221L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5537 103.293 85.2591L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4097 70.2629L97.5626 85.3623C98.1158 84.6666 98.9135 84.174 99.8257 84.0145V70.2629L71.4097 70.2629Z",
    fill: "#037C84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.984 65H115.766V71.3281H119.984V65Z",
    fill: "#283366"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.422 65H124.203V71.3281H128.422V65Z",
    fill: "#283366"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.656 82.0156H107.328V86.2344H113.656V82.0156Z",
    fill: "#283366"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137 82.0156H130.531V86.2344H137V82.0156Z",
    fill: "#283366"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.656 73.4375H107.328V77.6562H113.656V73.4375Z",
    fill: "#283366"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137 73.4375H130.531V77.6562H137V73.4375Z",
    fill: "#283366"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.984 107.469H100.426V103.25H115.766V88.3438H119.984V107.469Z",
    fill: "#283366"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.422 115.906H100.656V111.688H124.203V88.3438H128.422V115.906Z",
    fill: "#283366"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.641 90.4531H111.547V69.2188H132.641V90.4531Z",
    fill: "#FDBF00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.422 73.4375H115.766V86.2344H128.422V73.4375Z",
    fill: "#283366"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.203 77.6562H119.984V82.0156H124.203V77.6562Z",
    fill: "#BBDCFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7846 106.501C89.3143 106.501 82.9066 107.769 76.9235 110.232L74.5056 111.228C78.3303 114.98 83.4755 117.086 88.8385 117.086H101V106.501H95.7846Z",
    fill: "#3B4B51"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.952 111.734C112.379 108.373 107.658 106.501 102.753 106.501H101V117.086H121.64L115.952 111.734Z",
    fill: "#292929"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7846 103.126C89.0054 103.126 82.3894 104.435 76.1206 107.016L65 111.595V115.625L69.1719 117.734L65 119.844V126.287L76.682 129.617H101L102.406 117.086L101 103.126H95.7846ZM88.8388 115.82C84.2666 115.82 79.8537 114.288 76.2814 111.512L77.7268 110.917C83.4836 108.547 89.5592 107.345 95.7848 107.345H98.8906V115.82H88.8388V115.82Z",
    fill: "#FE6666"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137 117.081L122.664 113.887L117.398 108.932C113.418 105.188 108.217 103.126 102.753 103.126H101V129.617H137V117.081ZM103.109 115.82V107.349C107.364 107.436 111.399 109.082 114.507 112.005L118.562 115.82H103.109Z",
    fill: "#FE3377"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65 115.625H71.3446V119.844H65V115.625Z",
    fill: "#FFDD00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6021 134.891C85.5145 134.891 87.8755 132.53 87.8755 129.617C87.8755 126.705 85.5145 124.344 82.6021 124.344C79.6896 124.344 77.3286 126.705 77.3286 129.617C77.3286 132.53 79.6896 134.891 82.6021 134.891Z",
    fill: "#EBE5F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6018 137C78.5309 137 75.219 133.688 75.219 129.617C75.219 125.546 78.5309 122.234 82.6018 122.234C86.6728 122.234 89.9846 125.546 89.9846 129.617C89.9846 133.688 86.6728 137 82.6018 137ZM82.6018 126.453C80.8571 126.453 79.4377 127.872 79.4377 129.617C79.4377 131.362 80.8571 132.781 82.6018 132.781C84.3465 132.781 85.7659 131.362 85.7659 129.617C85.7659 127.872 84.3465 126.453 82.6018 126.453Z",
    fill: "#404A7F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.21 134.891C125.123 134.891 127.484 132.53 127.484 129.617C127.484 126.705 125.123 124.344 122.21 124.344C119.298 124.344 116.937 126.705 116.937 129.617C116.937 132.53 119.298 134.891 122.21 134.891Z",
    fill: "#CECEE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M122.211 137C118.14 137 114.828 133.688 114.828 129.617C114.828 125.546 118.14 122.234 122.211 122.234C126.282 122.234 129.594 125.546 129.594 129.617C129.594 133.688 126.282 137 122.211 137ZM122.211 126.453C120.466 126.453 119.047 127.872 119.047 129.617C119.047 131.362 120.466 132.781 122.211 132.781C123.955 132.781 125.375 131.362 125.375 129.617C125.375 127.872 123.955 126.453 122.211 126.453Z",
    fill: "#283366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAuto);
export default __webpack_public_path__ + "static/media/Logo_auto.858247cbeb67646b96443740522fa243.svg";
export { ForwardRef as ReactComponent };